<template>
  <div id="TabContract" class="table-responsive-sm">
    <section>
      <div class="btn-groups badge-buttons text-left mb-3">
          <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
            <!-- <button type="button" id="getPastReservationList" v-on:click="getPastReservationList(this)" :class="'btn btn-secondary '+ pastActive"> Past <span> {{pastReservationCnt}} </span> </button> -->
            <button type="button" id="getRentalAgreements" v-on:click="getRentalAgreements(this)" :class="'btn btn-secondary '+ rentalAgreementActive"> Rental Agreements ({{rentalAgreementDeposit}})</button>
            <button type="button" id="getLeaseContracts" v-on:click="getLeaseContracts(this)" :class="'btn btn-secondary '+ leaseContractsActive"> Lease Contracts ({{contractLeaseDeposit}}) </button>
            <button type="button" id="getOthers" v-on:click="getOthers(this)" :class="'btn btn-secondary '+ othersActive"> Others ({{othersDeposit}})</button>
          </div>
          <div class="row" style="padding-top: 3%">
            <div class="=col-6" style="padding-left: 2%">
              <b>Total Deposit:</b> {{totalDeposit}}
            </div>
            <div class="=col-6" style="padding-left: 50%">
              <b>Remaining Deposit:</b> {{remainingDeposit}}
            </div>
          </div>
      </div>
      <customer-exposure-rental-agreement id="rentalAgreements" :tableData="dataForRentalAgreement" v-if="rentalAgreementsIs === true"></customer-exposure-rental-agreement>
      <customer-exposure-lease-contract id="leaseContracts" :tableData="dataForContractLease" v-if="leaseContractsIs"></customer-exposure-lease-contract>
      <customer-exposure-other id="others" :tableData="dataForOthers" v-if="othersIs"></customer-exposure-other>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import EventBus from ".././event-bus";
import {commonMixins} from "../../mixins/commonMixins";

import LoadingContent from "../LoadingContent.vue";
import CustomerExposureRentalAgreement from "./CustomerExposureRentalAgreement.vue";
import CustomerExposureLeaseContract from "./CustomerExposureLeaseContract.vue";
import CustomerExposureOther from "./CustomerExposureOther.vue";


Vue.component("customer-exposure-rental-agreement", CustomerExposureRentalAgreement);
Vue.component("customer-exposure-lease-contract", CustomerExposureLeaseContract);
Vue.component("customer-exposure-other", CustomerExposureOther);

export default {
  name: "CustomerExposureComponent",
  props: {
    dataForTables: {},
  },
  mixins: [commonMixins],
  data: () => ({
    rentalAgreementsIs:false,
    leaseContractsIs:false,
    othersIs:false,
    rentalAgreementActive: "",
    leaseContractsActive: "",
    othersActive: "",
    dataForContractLease: [],
    dataForRentalAgreement: [],
    dataForOthers: [],
    rentalAgreementDeposit: "",
    contractLeaseDeposit: "",
    othersDeposit: "",
    totalDeposit: "",
    remainingDeposit: "",
    dataForTablesObject: {},
  }),

  mounted: function () {
    var self = this;
  },

  methods: {
    getRentalAgreements: function(){
      var self = this;
      $('#divTabMenu button').removeClass("active");
      $('#getRentalAgreements').addClass("active");
      self.leaseContractsIs = false;
      self.$nextTick().then(() => {
        self.rentalAgreementsIs = true;
      });
      self.othersIs = false;
    },
    getLeaseContracts: function(){
      var self = this;
      $('#divTabMenu button').removeClass("active");
      $('#getLeaseContracts').addClass("active");
      self.leaseContractsIs = true;
      self.rentalAgreementsIs = false;
      self.othersIs = false;
    },
    getOthers: function(){
      var self = this;
      $('#divTabMenu button').removeClass("active");
      $('#getOthers').addClass("active");
      self.leaseContractsIs = false;
      self.rentalAgreementsIs = false;
      self.othersIs = true;
    },
  },
  watch: {
    dataForTables(value) {
      try {
        this.dataForTablesObject = value;
        this.dataForOthers = this.dataForTablesObject.others;
        this.dataForContractLease = this.dataForTablesObject.contract;
        this.dataForRentalAgreement = this.dataForTablesObject.agreement;

        this.rentalAgreementDeposit= this.dataForTablesObject.deposit.ag_deposit_required;
        this.contractLeaseDeposit= this.dataForTablesObject.deposit.con_deposit_required;
        this.othersDeposit= this.dataForTablesObject.deposit.other_deposit;
        this.totalDeposit = this.dataForTablesObject.deposit.total_deposit;
        this.remainingDeposit = this.dataForTablesObject.deposit.deposit_remain;
        if (typeof this.dataForOthers === 'undefined'){
          this.dataForOthers = [];
        }

        if (typeof this.dataForContractLease === 'undefined'){
          this.dataForContractLease = [];
        }

        if (typeof this.dataForRentalAgreement === 'undefined'){
          this.dataForRentalAgreement = [];
        }

        if (typeof this.rentalAgreementDeposit === 'undefined'){
          this.rentalAgreementDeposit = "$0.00";
        }
        if (typeof this.contractLeaseDeposit === 'undefined'){
          this.contractLeaseDeposit = "$0.00";
        }
        if (typeof this.othersDeposit === 'undefined'){
          this.othersDeposit = "$0.00";
        }
        if (typeof this.totalDeposit === 'undefined'){
          this.totalDeposit = "$0.00";
        }
        if (typeof this.remainingDeposit === 'undefined'){
          this.remainingDeposit = "$0.00";
        }
        this.getRentalAgreements();
      }catch (e) {
          console.log('ERROR=>',e);
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/customer/CustomerExposureComponent.vue